module.exports = __webpack_public_path__ + "img/icon_exchange_display.c9e30e28.png";